import type { FC } from "react";
import { useFormContext } from "react-hook-form";

import type { BirthFormDropdowns } from "@ui/eva-components/SoftAgeVerification/SoftAgeVerification";

import type { BirthDateFormDropdownsFormat } from "../../BirthDateFormInputs";
import { useMinimumAgeValidator } from "../../useMinimumAgeValidator";
import { DayInput } from "../DayInput/DayInput";
import { MonthInput } from "../MonthInput/MonthInput";
import { YearInput } from "../YearInput/YearInput";

type BirthDateDropdownsProps = {
  dayPlaceholder: string;
  monthPlaceholder: string;
  yearPlaceholder: string;
  dayAriaLabel: string;
  monthAriaLabel: string;
  yearAriaLabel: string;
  minimumAge: number;
  format: BirthDateFormDropdownsFormat;
};

export const BirthDateDropdowns: FC<BirthDateDropdownsProps> = ({
  dayPlaceholder,
  monthPlaceholder,
  yearPlaceholder,
  dayAriaLabel,
  monthAriaLabel,
  yearAriaLabel,
  minimumAge,
  format,
}) => {
  const { watch, setError, clearErrors } = useFormContext<BirthFormDropdowns>();
  const validateMinimumAge = useMinimumAgeValidator();
  watch((values) => {
    const year = Number(values?.year?.value);
    const month = format === "yyyy" ? 1 : Number(values?.month?.value);
    const day = format === "dd/mm/yyyy" ? Number(values?.day?.value) : 1;

    validateMinimumAge({
      year,
      month,
      day,
      minimumAge,
      setMinimumAgeError: () => setError("minimumAge", {}),
      clearMinimumAgeError: () => clearErrors("minimumAge"),
    });
  });
  return (
    <>
      {format === "dd/mm/yyyy" && <DayInput type="select" placeholder={dayPlaceholder} ariaLabel={dayAriaLabel} />}
      {format !== "yyyy" && <MonthInput type="select" placeholder={monthPlaceholder} ariaLabel={monthAriaLabel} />}
      <YearInput minimumAge={minimumAge} type="select" placeholder={yearPlaceholder} ariaLabel={yearAriaLabel} />
    </>
  );
};
